import TableContent from './TableContent'

export default TableContent



// WEBPACK FOOTER //
// ./src/views/Divisions/components/TableContent/index.js